'use strict'

// Which submission rule runs after a form is saved. The live app uses this for
// redirects and refreshes. The app server uses the same match for record writes.
// A submission rule is not tied to one column, so a "form field" condition
// reads condition.field. Related conditions need a database read and do not match here.

const { matchesDisplayCondition } = require('./display-rules')

function castValue (value, dataType) {

  if (dataType === 'number') {
    const num = Number(value)
    return Number.isNaN(num) ? value : num
  }

  if (dataType === 'checkbox') {
    if (value === 'true' || value === true) return true
    if (value === 'false' || value === false) return false
    return !!value
  }

  return value
}

function submissionContext (input) {

  const flag = input && input.openInModal

  return { openInModal: flag === true || flag === 'true' || flag === '1' || flag === 1 }
}

function conditionMatches (condition, recordValues, context) {

  if (!condition || condition.source === 'related') return false
  if (condition.source === 'modal') return !!(context && context.openInModal)
  if (condition.source === 'none') return true

  const values = recordValues || {}
  let testValue = values[condition.field]
  const conditionValue = castValue(condition.value, condition.dataType)

  if (condition.dataType === 'number') testValue = castValue(testValue, 'number')
  else if (condition.dataType === 'checkbox') testValue = castValue(testValue, 'checkbox')

  return matchesDisplayCondition(testValue, condition.operator, conditionValue, condition.dataType)
}

function conditionsMatch (conditions, matchMode, recordValues, context) {

  const list = conditions || []

  if (!list.length) return true
  if (matchMode === 'any') return list.some((condition) => conditionMatches(condition, recordValues, context))

  return list.every((condition) => conditionMatches(condition, recordValues, context))
}

function ruleMatches (rule, recordValues, context) {

  if (!rule) return false
  if (rule.type === 'else') return true

  const conditions = (rule.conditions || []).filter((condition) => condition && condition.source !== 'none')
  const always = (rule.conditions || []).some((condition) => condition && condition.source === 'none')

  if ((always && conditions.length === 0) || conditions.length === 0) return true

  return conditionsMatch(conditions, rule.conditionMatchMode || 'all', recordValues, context)
}

function matchingSubmissionActions (submissionRules, recordValues, context) {

  const rules = submissionRules && submissionRules.rules

  if (!Array.isArray(rules) || !rules.length) return null

  for (const rule of rules) {

    if (!ruleMatches(rule, recordValues, context)) continue

    return rule.actions && rule.actions.length ? rule.actions : null
  }

  return null
}

module.exports = {
  matchingSubmissionActions,
  ruleMatches,
  submissionContext
}
